<div class="d-flex min-vh-75 w-100 flex-column justify-content-center">
    <div class="">                    
        <p class="fw-semi-bold">(5 of 10) Foot Care</p>
        <div class="progress" style="height:8px">
        <div class="progress-bar" role="progressbar" style="width: 50%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
    </div>
    <div class="flex-grow-1 "></div>
    <div class="d-flex d-flex justify-content-center">

        <div class="assessment-block">
            
            <p class="question-header">How often do you inspect your feet for any signs of complications?</p>            
            <div class="form-check ps-10 pe-10">
                <input [(ngModel)]="assessment.footCareQ1" class="btn-check" id="q1" type="radio" name="question1" value="Daily" (change)="onChange()"/>        
                <label class="btn btn-small btn-outline-secondary w-100" for="q1">Daily</label>
            </div>
            <div class="form-check ps-10 pe-10">        
                <input [(ngModel)]="assessment.footCareQ1" class="btn-check" id="q2" type="radio" name="question1" value="Weekly" (change)="onChange()"/>
                <label class="btn btn-outline-secondary w-100" for="q2">Weekly</label>
            </div>
            <div class="form-check ps-10 pe-10">        
                <input [(ngModel)]="assessment.footCareQ1" class="btn-check" id="q3" type="radio" name="question1" value="Rarely or never" (change)="onChange()"/>
                <label class="btn btn-outline-secondary w-100" for="q3">Rarely or never</label>
            </div>


            <p class="question-header mt-6">Have you noticed any changes in sensation or skin condition on your feet?</p>
            <div class="form-check ps-10 pe-10">
                <input [(ngModel)]="assessment.footCareQ2" class="btn-check" id="q4" type="radio" name="question2" value="Yes" (change)="onChange()"/>        
                <label class="btn btn-outline-secondary w-100" for="q4">Yes</label>
            </div>
            <div class="form-check ps-10 pe-10">        
                <input [(ngModel)]="assessment.footCareQ2" class="btn-check" id="q5" type="radio" name="question2" value="No" (change)="onChange()"/>
                <label class="btn btn-outline-secondary w-100" for="q5">No</label>
            </div>            

        </div>
    </div>
    <div class="p-2 flex-grow-1"></div>
    
    <div class="d-flex mb-2">
        <div class="me-auto p-2">
            <button class="btn btn-link" (click)="_prevButton()" type="submit">Prev</button>
        </div>
        <div class="p-2">
        <button class="btn btn-link" (click)="_nextButton()" type="submit">Skip</button>
        </div>
        <div class="p-2">
        <button class="btn btn-primary" (click)="_nextButton()" type="submit">Next</button>
        </div>
    </div>
</div>
